import axios from "../../utils/axiosConfig.js";
import { server } from "../../server/server.jsx";


// Get Settings
export const getSettings = () => async (dispatch) => {
  try {
    dispatch({ type: "getSettingsRequest" });

    const { data } = await axios.get(`${server}/settings/get-settings`, {
      withCredentials: true,
    });

    dispatch({
      type: "getSettingsSuccess",
      payload: data.settings,
    });
  } catch (error) {
    dispatch({
      type: "getSettingsFail",
      payload: error.response?.data?.message || 'Something went wrong',
    });
  }
};

// get subscription plan
export const getSubscriptionPlan = () => async (dispatch) => {
  try {
    dispatch({ type: "getSubscriptionPlanRequest" });

    const { data } = await axios.get(`${server}/settings/get-subscription-plan`, {
      withCredentials: true,
    });

    dispatch({
      type: "getSubscriptionPlanSuccess",
      payload: data.subscriptionPlan,
    });
  } catch (error) {
    dispatch({
      type: "getSubscriptionPlanFail",
      payload: error.response?.data?.message || 'Something went wrong',
    });
  }
};

// Update Receipt Settings
export const updateReceiptSettings = (receiptData) => async (dispatch) => {
  try {
    dispatch({ type: "updateReceiptSettingsRequest" });

    const { data } = await axios.post(`${server}/settings/update-receipt-settings`, receiptData, {
      withCredentials: true,
    });

    dispatch({
      type: "updateReceiptSettingsSuccess",
      payload: data.settings,
    });

    dispatch(getSettings());
  } catch (error) {
    dispatch({
      type: "updateReceiptSettingsFail",
      payload: error.response?.data?.message || 'Something went wrong',
    });
  }
};

// Update Subscription Plan
export const updateSubscriptionPlan = (subscriptionData) => async (dispatch) => {
  try {
    dispatch({ type: "updateSubscriptionPlanRequest" });

    const { data } = await axios.post(`${server}/settings/update-subscription-plan`, subscriptionData, {
      withCredentials: true,
    });

    dispatch({
      type: "updateSubscriptionPlanSuccess",
      payload: data.settings,
    });
  } catch (error) {
    dispatch({
      type: "updateSubscriptionPlanFail",
      payload: error.response?.data?.message || 'Something went wrong',
    });
  }
};

// Activate Subscription
export const activateSubscription = (subscriptionData) => async (dispatch) => {
  try {
    dispatch({ type: "activateSubscriptionRequest" });

    const { data } = await axios.put(`${server}/settings/activate-subscription`, subscriptionData, {
      withCredentials: true,
    });

    dispatch({
      type: "activateSubscriptionSuccess",
      payload: data.settings,
    });

    dispatch(getSettings());
  } catch (error) {
    dispatch({
      type: "activateSubscriptionFail",
      payload: error.response?.data?.message || 'Something went wrong',
    });
  }
};

// Deactivate Subscription
export const deactivateSubscription = () => async (dispatch) => {
  try {
    dispatch({ type: "deactivateSubscriptionRequest" });

    const { data } = await axios.put(`${server}/settings/deactivate-subscription`, {}, {
      withCredentials: true,
    });

    dispatch({
      type: "deactivateSubscriptionSuccess",
      payload: data.settings,
    });
  } catch (error) {
    dispatch({
      type: "deactivateSubscriptionFail",
      payload: error.response?.data?.message || 'Something went wrong',
    });
  }
};